import React, { useState, useEffect } from 'react';
import './FontLoader.css';

function FontLoader({ children }) {
    const [isFontLoaded, setIsFontLoaded] = useState(false);

    useEffect(() => {
        const checkFonts = async () => {
            try {
                await document.fonts.load('1em Bruno Ace');
                await document.fonts.load('1em Audiowide');

                const isBrunoAceLoaded = document.fonts.check('1em Bruno Ace');
                const isAudiowideLoaded = document.fonts.check('1em Audiowide');
                
                if (isBrunoAceLoaded && isAudiowideLoaded) {
                    setIsFontLoaded(true);
                }
            } catch (error) {
                console.error('폰트 로딩 중 오류:', error);
            }
        };

        checkFonts();
    }, []);

    if (!isFontLoaded) {
        return (
            <div className="font-loader">
                <div className="loading-spinner"></div>
                <div className="loading-text">AIIA</div>
                <div className="loading-subtext">
                    <div>Artificial</div>
                    <div>Intelligence</div>
                    <div>In Actions</div>
                </div>
            </div>
        );
    }

    return children;
}

export default FontLoader; 